/* eslint-disable global-require */
import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Chat from './index';
import { BotsCreators } from '../../store/actions/bots';

import actions from '../../store/actions';
import './index.scss';

const BotTest = (props) => {
  const { showTest, botId, bot } = props;

  const startPreviewBot = (event) => {
    event.preventDefault();

    const { openPreviewBot } = props;
    openPreviewBot();

    setTimeout(() => {
      const chat = document.getElementById('bot-test-chat');
      if (chat) chat.classList.toggle('is-chat-open');
    }, 200);
  };

  return (
    <Fragment>
      <button type="button" className="fab-bot-test" onClick={startPreviewBot}>
        <img src={require('../../assets/images/testar.svg')} alt="" />
      </button>
      {showTest ? (
        <div id="bot-test-chat" className="chat">
          <Chat title={bot.title} botId={botId} />
        </div>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...BotsCreators,
      ...actions.previewBot,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BotTest);
